import Route from '@ember/routing/route';

import type SettingsEmailTemplatesShowController from '../controller';

export default class SettingsEmailTemplatesShowIndexRouteParams extends Route {
  declare controller: SettingsEmailTemplatesShowController;
  controllerName = 'visitors.settings.email-templates.show';
}
